export default {
    Crossword: function(params) {
        //usage:
        //var myCrossword = new Crossword({
        //  node:document.getElementById('whatever'),
        //  termDescriptionPairs:[
        //      {term:'joke', description:'Something funny you tell people.'},
        //      {term:'happy', description:'The opposite of sad.'},
        //      {term:'parade', description:'People marching down the street.'}
        //  ]
        //});

        var me;

        me = this;
        me.myParams = params;
        if (!me.myParams.allow_special_characters) {
            for (var i = 0; i < me.myParams.termDescriptionPairs.length; i++) {
                var pair = me.myParams.termDescriptionPairs[i];
                // Remove whitespace characters, dashes, parens and dots
                pair.term = pair.term.replace(/[\s\-().]/g, '');
            }
        }
        me.previewMode = me.myParams.previewMode;
        me.placementNode = me.myParams.node;
        me.placementNode.innerHTML = '';
        me.termsUnplaced = cloneObject(me.myParams.termDescriptionPairs);
        me.termsPlaced = [];
        me.termsUnplaceable = [];
        me.termsUnplaceables = [];
        me.grid = [];
        me.answerKey = [];
        me.inputOrder = {};
        me.lastWord = null;
        me.inputValue = null;
        me.grids = [];
        me.answerKeys = [];
        me.termsPlaceds = [];
        me.numberOfAttempts = 100;
        me.seed = me.myParams.seed;

        function sortByLength(a, b) {
            //sorts by term length ascending

            if (a.term.length < b.term.length) {
                return -1;
            } else if (a.term.length > b.term.length) {
                return 1;
            } else {
                return 0;
            }
        }

        function sortWordList(termDescriptionPairs) {
            //sort the word list

            return termDescriptionPairs.sort(sortByLength);
        }

        function sortGridScore(a, b) {
            //sort ascending:

            if (a.score < b.score) {
                return -1;
            } else if (a.score > b.score) {
                return 1;
            } else {
                return 0;
            }
        }

        function sortGridPlacedTerms(a, b) {
            //sort ascending:

            if (a.termsPlacedNum < b.termsPlacedNum) {
                return -1;
            } else if (a.termsPlacedNum > b.termsPlacedNum) {
                return 1;
            } else {
                return 0;
            }
        }

        function placeWord(termDescriptionPair, position) {
            //places the specified term at the position in the grid coordinate specified

            var termLength, x, y, direction;

            x = position.x;
            y = position.y;
            direction = position.direction;
            termLength = termDescriptionPair.term.length;

            me.termsPlaced.push({
                'term': termDescriptionPair.term,
                'description': termDescriptionPair.description,
                'x': x,
                'y': y,
                'direction': direction
            });
            for (var i = 0; i < termLength; i++) {
                me.grid[y][x].letter = termDescriptionPair.term[i];
                me.grid[y][x].blocked = false;
                if (/^\d+$/.test(me.grid[y][x].wordIndex)) {
                    if (direction == 'horizontal') {
                        me.grid[y][x].wordIndex = me.termsPlaced.length + ' ' + me.grid[y][x].wordIndex;
                    } else { //vertical:
                        me.grid[y][x].wordIndex = me.grid[y][x].wordIndex + ' ' + me.termsPlaced.length;
                    }
                } else {
                    me.grid[y][x].wordIndex = me.termsPlaced.length + '';
                }
                if (i == 0) {
                    me.grid[y][x].firstLetter = true;
                    me.grid[y][x].wordDirection = direction;
                }
                if (direction == 'horizontal') {
                    x++;
                } else if (direction == 'vertical') {
                    y++;
                }
            }
            if (direction == 'horizontal') {
                if (me.grid[position.y][position.x - 1] != undefined) {
                    me.grid[position.y][position.x - 1].blocked = true;
                }
                if (me.grid[position.y][position.x + termLength] != undefined) {
                    me.grid[position.y][position.x + termLength].blocked = true;
                }
            } else if (direction == 'vertical') {
                if (me.grid[position.y - 1] != undefined) {
                    me.grid[position.y - 1][position.x].blocked = true;
                }
                if (me.grid[position.y + termLength] != undefined) {
                    me.grid[position.y + termLength][position.x].blocked = true;
                }
            }
            me.termsUnplaced.pop();
        }

        function getRandomDirection() {
            //randomly returns 'horizontal' or 'vertical', this is used to add some randomness

            if (Math.floor(customRandom() * 2)) {
                return 'horizontal';
            } else {
                return 'vertical';
            }
        }

        function getRandomBoolean() {
            //randomly returns true or false, this is used several places to add some randomness

            if (Math.floor(customRandom() * 2)) {
                return true;
            } else {
                return false;
            }
        }

        function customRandom() {
            var x = Math.sin(me.seed++) * 10000;
            return x - Math.floor(x);
        }

        //TODO: use the cloneObject global instead:
        function cloneObject(obj) {
            var i, clone;

            if (!obj) {
                return obj;
            } else if (Array.isArray(obj)) {
                clone = [];
            } else if (typeof obj === 'object') {
                clone = {};
            } else {
                return obj;
            }

            for (i in obj) {
                if (typeof(obj[i]) == "object") {
                    clone[i] = cloneObject(obj[i]);
                } else {
                    clone[i] = obj[i];
                }
            }
            return clone;
        }

        function findWordIntersects(unplacedTermOffset) {
            //finds all possible locations where the given term can intersect with those already placed in the grid. unplacedTermOffset is the offset of the term in the me.termsUnplaced array that we're evaluating

            var word, intersects, termsPlacedLength, currentLetter, currentTerm, wordLength, currentLetterIndex, lastFoundOffset;

            word = me.termsUnplaced[unplacedTermOffset].term;
            wordLength = word.length;
            intersects = [];

            termsPlacedLength = me.termsPlaced.length;
            for (currentTerm = termsPlacedLength - 1; currentTerm >= 0; currentTerm--) {
                for (currentLetter = 0; currentLetter < wordLength; currentLetter++) {
                    lastFoundOffset = 0;
                    do {
                        currentLetterIndex = me.termsPlaced[currentTerm].term.indexOf(word[currentLetter], lastFoundOffset);
                        if (currentLetterIndex != -1) {
                            intersects.push({
                                placedTermOffset: currentTerm,
                                placedLetterOffset: currentLetterIndex,
                                'unplacedTermOffset': unplacedTermOffset,
                                unplacedLetterOffset: currentLetter
                            });
                            lastFoundOffset = currentLetterIndex + 1;
                        }
                    } while (currentLetterIndex != -1);
                }
            }
            return intersects;
        }

        function findPreferredIntersect(intersects) {
            //evaluates potential locations where words can intersect and returns the preferred location

            var i, intersectsLength, unplacedWordLength, startX, startY, currentX, currentY, intersectOk;

            intersectsLength = intersects.length;
            for (i = 0; i < intersectsLength; i++) {
                intersectOk = true;
                unplacedWordLength = me.termsUnplaced[intersects[i].unplacedTermOffset].term.length;
                //if direction of already placed term is horizontal, we will place vertical:
                if (me.termsPlaced[intersects[i].placedTermOffset].direction == 'horizontal') {
                    startX = me.termsPlaced[intersects[i].placedTermOffset].x + intersects[i].placedLetterOffset;
                    startY = me.termsPlaced[intersects[i].placedTermOffset].y - intersects[i].unplacedLetterOffset;
                    currentX = startX;
                    if (me.grid[startY] == undefined || me.grid[startY][startX] == undefined) {
                        intersectOk = false;
                    } else if (me.grid[startY][startX].firstLetter) {
                        intersectOk = false;
                    } else if (me.grid[startY - 1] != undefined &&
                        me.grid[startY - 1][startX].letter != undefined &&
                        me.grid[startY - 1][startX].letter != '') {
                        intersectOk = false;
                    } else if (me.grid[startY + unplacedWordLength] != undefined &&
                        me.grid[startY + unplacedWordLength][startX].letter != undefined &&
                        me.grid[startY + unplacedWordLength][startX].letter != '') {
                        intersectOk = false;
                    } else {
                        for (currentY = startY; currentY < startY + unplacedWordLength; currentY++) {
                            if (me.grid[currentY] == undefined || me.grid[currentY][currentX] == undefined || me.grid[currentY][currentX].blocked) {
                                intersectOk = false;
                                break;
                            } else if (me.grid[currentY][currentX].letter != undefined &&
                                me.grid[currentY][currentX].letter != '' &&
                                me.grid[currentY][currentX].letter != me.termsUnplaced[intersects[i].unplacedTermOffset].term[currentY - startY]) {
                                intersectOk = false;
                                break;
                            }
                        }
                    }
                } else { //if direction of already placed term is vertical, we will place horizontal:
                    startX = me.termsPlaced[intersects[i].placedTermOffset].x - intersects[i].unplacedLetterOffset;
                    startY = me.termsPlaced[intersects[i].placedTermOffset].y + intersects[i].placedLetterOffset;
                    currentY = startY;
                    if (me.grid[startY] == undefined || me.grid[startY][startX] == undefined) {
                        intersectOk = false;
                    } else if (me.grid[startY][startX].firstLetter) {
                        intersectOk = false;
                    } else if (me.grid[startY][startX - 1] != undefined &&
                        me.grid[startY][startX - 1].letter != undefined &&
                        me.grid[startY][startX - 1].letter != '') {
                        intersectOk = false;
                    } else if (me.grid[startY][startX + unplacedWordLength] != undefined &&
                        me.grid[startY][startX + unplacedWordLength].letter != undefined &&
                        me.grid[startY][startX + unplacedWordLength].letter != '') {
                        intersectOk = false;
                    } else {
                        for (currentX = startX; currentX < startX + unplacedWordLength; currentX++) {
                            if (me.grid[currentY] == undefined || me.grid[currentY][currentX] == undefined || me.grid[currentY][currentX].blocked) {
                                intersectOk = false;
                                break;
                            } else if (me.grid[currentY][currentX].letter != undefined &&
                                me.grid[currentY][currentX].letter != '' &&
                                me.grid[currentY][currentX].letter != me.termsUnplaced[intersects[i].unplacedTermOffset].term[currentX - startX]) {
                                intersectOk = false;
                                break;
                            }
                        }
                    }
                }
                if (intersectOk) {
                    return {
                        placedTermOffset: intersects[i].placedTermOffset,
                        placedLetterOffset: intersects[i].placedLetterOffset,
                        unplacedTermOffset: intersects[i].unplacedTermOffset,
                        unplacedLetterOffset: intersects[i].unplacedLetterOffset
                    };
                }
            }

            return null;
        }

        function findClearLocation(unplacedTermIndex) {

            console.log('unplacedTermIndex', unplacedTermIndex);
            var x, y, row, col, l, hOk, vOk;
            for (row = 1; row < me.grid.length; row += 2) {
                //console.log('row', row, me.grid.length );
                for (col = 1; col < me.grid[0].length; col += 2) {
                    //console.log('column', col, me.grid[0].length);
                    x = col;
                    y = row;
                    hOk = true;
                    vOk = true;
                    for (l = 0; l < me.termsUnplaced[unplacedTermIndex].term.length; l++) {
                        //console.log('me.grid[y]', me.grid[y], l);
                        if (me.grid[y] == undefined ||
                            me.grid[y][x + l] == undefined ||
                            me.grid[y][x + l].blocked ||
                            me.grid[y][x + l].letter == undefined ||
                            me.grid[y][x + l].letter != '') {
                            hOk = false;
                        }
                        //console.log('me.grid[y+l]', me.grid[y+l], l);
                        if (me.grid[y + l] == undefined ||
                            me.grid[y + l][x] == undefined ||
                            me.grid[y + l][x].blocked ||
                            me.grid[y + l][x].letter == undefined ||
                            me.grid[y + l][x].letter != '') {
                            vOk = false;
                        }
                    }
                    if (hOk) {
                        return {
                            'x': x,
                            'y': y,
                            'direction': 'horizontal'
                        };
                    } else if (vOk) {
                        return {
                            'x': x,
                            'y': y,
                            'direction': 'vertical'
                        };
                    }
                }
            }
            return null;
        }

        function findPlacementLocation(unplacedTermIndex, roundDownFirst, noIntersect) {
            //finds a place to put an unplaced term. unplacedTermIndex is the offset of the term to evaluate found in the me.unplacedTerms array. roundDownFirst, when true places the first term by rounding down the location of the first square. This allows for a variation for further evaluation of optimal grid.
            var gridWidth, gridLength, location, yCoord, xCoord, currentDirection, intersects, preferredIntersect, placedIntersectWord, placedIntersectLetter, unplacedIntersectLetter, clearLocation;

            gridWidth = me.grid[0].length;
            gridLength = me.grid.length;
            currentDirection = getRandomDirection();
            //      currentDirection = 'vertical'; //hard-code direction for testing
            location = {};
            noIntersect = noIntersect || false;

            if (noIntersect) {
                clearLocation = findClearLocation(unplacedTermIndex);
                if(clearLocation != undefined){
                    yCoord = clearLocation.y;
                    xCoord = clearLocation.x;
                    currentDirection = clearLocation.direction;
                }
                else{
                    return null;
                }
            } else if (me.termsPlaced.length == 0) {
                //this is the first term to be placed:
                if (currentDirection == 'horizontal') {
                    yCoord = gridLength / 2;
                    if (!isEven(yCoord)) {
                        yCoord--;
                    }
                    if (roundDownFirst) { //this can drastically change the grid generation
                        xCoord = Math.floor(gridLength / 2 - me.termsUnplaced[unplacedTermIndex].term.length / 2);
                    } else {
                        xCoord = Math.floor(gridLength / 2 - me.termsUnplaced[unplacedTermIndex].term.length / 2) + 1;
                    }
                } else { //direction will be vertical:
                    xCoord = gridWidth / 2;
                    if (!isEven(xCoord)) {
                        xCoord--;
                    }
                    if (roundDownFirst) { //this can drastically change the grid generation
                        yCoord = Math.floor(gridWidth / 2 - me.termsUnplaced[unplacedTermIndex].term.length / 2);
                    } else {
                        yCoord = Math.floor(gridWidth / 2 - me.termsUnplaced[unplacedTermIndex].term.length / 2) + 1;
                    }
                }
            } else {
                //all subsequent terms are placed in this way:
                //find a placed word that has a letter to intersect with this one:
                intersects = findWordIntersects(unplacedTermIndex);
                preferredIntersect = findPreferredIntersect(intersects);
                //handle the case where no preferred intersect is found by putting the word into a holding array:
                if (preferredIntersect == null) {
                    me.termsUnplaceable.push(me.termsUnplaced[unplacedTermIndex]);
                    me.termsUnplaced.pop();
                    return null;
                }
                placedIntersectWord = preferredIntersect.placedTermOffset;
                placedIntersectLetter = preferredIntersect.placedLetterOffset;
                unplacedIntersectLetter = preferredIntersect.unplacedLetterOffset;
                //set currentDirection to the direction opposite that of the word to intersect with:
                currentDirection = 'horizontal';
                if (me.termsPlaced[placedIntersectWord].direction == 'horizontal') {
                    currentDirection = 'vertical';
                }
                if (currentDirection == 'horizontal') {
                    yCoord = me.termsPlaced[placedIntersectWord].y + placedIntersectLetter;
                    xCoord = me.termsPlaced[placedIntersectWord].x - unplacedIntersectLetter;
                } else { //direction will be vertical:
                    yCoord = me.termsPlaced[placedIntersectWord].y - unplacedIntersectLetter;
                    xCoord = me.termsPlaced[placedIntersectWord].x + placedIntersectLetter;
                }
            }

            if(xCoord == undefined || yCoord == undefined || currentDirection == undefined){
                console.log('undefined items', unplacedTermIndex);
            }

            location = {
                x: xCoord,
                y: yCoord,
                direction: currentDirection
            };

            return location;
        }

        function isEven(number) {
            //evaluates a number to determine if it's even or odd.

            if (number % 2 === 0) {
                return true;
            } else {
                return false;
            }
        }

        

        // function clearCrossword(myForm) {
        //  //blanks out the crossword to start over
        //
        //  var myInputs, myInputsLength, i;
        //
        //  myForm.reset();
        //  myInputs = myForm.getElementsByTagName('input');
        //  myInputsLength = myInputs.length;
        //  for (var i=0; i<myInputsLength; i++) {
        //      myInputs[i].parentNode.className = myInputs[i].parentNode.className.replace(/ correct\b/g, '');
        //      myInputs[i].parentNode.className = myInputs[i].parentNode.className.replace(/ incorrect\b/g, '');
        //  }
        // }

        function extendGrid(amount, direction) {
            //this extends the grid by the amount and in the direction specified.
            var row, column, gridLength, gridWidth, i;
            if (direction == 'horizontal') {
                gridLength = me.grid.length;
                for (row = 0; row < gridLength; row++) {
                    if (!isEven(row + 1)) { //if the row is odd:
                        for (i = 0; i < amount; i++) {
                            me.grid[row].push({
                                blocked: false,
                                letter: '',
                                wordIndex: ''
                            }, {
                                blocked: false,
                                letter: '',
                                wordIndex: ''
                            });
                        }
                    } else { //if the row is even:
                        for (i = 0; i < amount; i++) {
                            me.grid[row].push({
                                blocked: false,
                                letter: '',
                                wordIndex: ''
                            }, {
                                blocked: true
                            });
                        }
                    }
                }
            } else if (direction == 'vertical') {
                gridWidth = me.grid[0].length / 2;
                for (i = 0; i < amount * 2; i++) {
                    row = me.grid.length;
                    me.grid[row] = [];
                    if (!isEven(row + 1)) { //if the row is odd:
                        for (column = 0; column < gridWidth; column++) {
                            me.grid[row].push({
                                blocked: false,
                                letter: '',
                                wordIndex: ''
                            }, {
                                blocked: false,
                                letter: '',
                                wordIndex: ''
                            });
                        }
                    } else { //if the row is even:
                        for (column = 0; column < gridWidth; column++) {
                            me.grid[row].push({
                                blocked: false,
                                letter: '',
                                wordIndex: ''
                            }, {
                                blocked: true
                            });
                        }
                    }
                }
            }
        }

        function generateGrid(maxLength) {
            //This generates the initial grid, sizing based on the length of the longest term and number of terms to be placed

            var halfMaxLength;

            me.grid = [
                [{
                    blocked: false,
                    letter: '',
                    wordIndex: ''
                }, {
                    blocked: false,
                    letter: '',
                    wordIndex: ''
                }],
                [{
                    blocked: false,
                    letter: '',
                    wordIndex: ''
                }, {
                    blocked: true
                }],
            ];

            if (!isEven(maxLength)) {
                maxLength += 1;
            }
            halfMaxLength = maxLength / 2;
            extendGrid((halfMaxLength - 1) * Math.ceil(me.termsUnplaced.length / 5) + 100, 'horizontal');
            extendGrid((halfMaxLength - 1) * Math.ceil(me.termsUnplaced.length / 5) + 100, 'vertical');
        }

        function cleanUnusedGrid() {
            //this trims off the unused rows and columns from the edges of the existing grid.

            var i, row, column, gridLength, gridWidth, rowUnused, columnUnused;

            gridWidth = me.grid[0].length;
            for (row = 0; row < me.grid.length; row++) {
                rowUnused = true;
                for (column = 0; column < gridWidth; column++) {
                    if (me.grid[row][column].letter != undefined &&
                        me.grid[row][column].letter != '') {
                        rowUnused = false;
                    }
                }
                if (rowUnused) {
                    me.grid.splice(row, 1);
                    row--;
                }
            }

            gridLength = me.grid.length;
            for (column = 0; column < me.grid[0].length; column++) {
                columnUnused = true;
                for (row = 0; row < gridLength; row++) {
                    if (me.grid[row][column].letter != undefined &&
                        me.grid[row][column].letter != '') {
                        columnUnused = false;
                    }
                }
                if (columnUnused) {
                    for (i = 0; i < gridLength; i++) {
                        me.grid[i].splice(column, 1);
                    }
                    column--;
                }
            }
        }

        function blockUnusedSpaces() {
            //mark spaces that went unused as "blocked" so that they display correctly. This is called after all terms that can be are placed

            var gridLength, gridWidth, column, row;

            gridLength = me.grid.length;
            gridWidth = me.grid[0].length;

            for (row = 0; row < gridLength; row++) {
                for (column = 0; column < gridWidth; column++) {
                    if (me.grid[row][column].blocked != true &&
                        (me.grid[row][column].letter == undefined ||
                            me.grid[row][column].letter == '')) {
                        me.grid[row][column].blocked = true;
                    }
                }
            }
        }

        function highlightSpaces() {
            //highlights the first square of the term as the mouse enters the corresponding clue

            var termOffset, firstSquare;

            termOffset = Number(this.getAttribute('value'));
            firstSquare = document.getElementById('w' + termOffset);
            firstSquare.parentNode.className += ' highlight';
            this.className += ' highlight';
        }

        function unHighlightSpaces() {
            //get's rid of the highlight on the first square of the term as the mouse leaves the corresponding clue

            var termOffset, firstSquare;

            termOffset = Number(this.getAttribute('value'));
            firstSquare = document.getElementById('w' + termOffset);
            firstSquare.parentNode.className = firstSquare.parentNode.className.replace(/ highlight\b/g, '');
            this.className = this.className.replace(/ highlight\b/g, '');
        }

        function positionCursor() {
            //places the cursor in the first square of the term in the grid when it's clue is clicked on

            var termOffset, firstSquare;

            termOffset = Number(this.getAttribute('value'));
            firstSquare = document.getElementById('w' + termOffset);
            firstSquare.focus();
        }

        function recordInputValue(e) {
            //keeps track of which character was last typed by the user, this is important later when handling backspace presses

            var myInput;

            e = e || window.event;
            myInput = e.target || e.srcElement;

            me.inputValue = myInput.value;
        }

        function focusNextInput(e) {
            //automatically moves the cursor to the next input as the user types so they can keep their hands on the keyboard

            var myInput, lastInputValue, wordAbbreviation, wordAbbreviations, wordLength, i, nextInput, nextInputNode, myForm, backspace, letterTyped;

            e = e || window.event;
            myInput = e.target || e.srcElement;

            lastInputValue = me.inputValue;
            me.inputValue = null;

            if (e.keyCode == 13) {
                return;
            } else if (e.keyCode != 8 && e.keyCode < 65 || e.keyCode > 90) {
                return;
            } else if (e.keyCode == 8) {
                if (lastInputValue != '') {
                    return;
                } else {
                    backspace = true;
                }
            }
            if (!backspace) {
                if (e.shiftKey) {
                    letterTyped = String.fromCharCode(e.keyCode).toUpperCase();
                    if (letterTyped.toLowerCase() != myInput.value.toLowerCase()) {
                        myInput.value = letterTyped;
                    }
                } else {
                    letterTyped = String.fromCharCode(e.keyCode).toLowerCase();
                    if (letterTyped.toLowerCase() != myInput.value.toLowerCase()) {
                        myInput.value = letterTyped;
                    }
                }
            }

            wordAbbreviation = myInput.name;
            wordAbbreviation = wordAbbreviation.replace(/l.*$/, '');
            wordAbbreviation = wordAbbreviation.replace(/^w-/, '');
            wordAbbreviations = wordAbbreviation.split(/_/);
            if (wordAbbreviations.length == 2 && me.lastWord == null && myInput.getAttribute('data-firstLetter') != 1) {
                wordAbbreviation = 'w' + wordAbbreviations[1];
            } else if (wordAbbreviations.length == 2 && me.lastWord == null && myInput.getAttribute('data-firstLetter') == 1) {
                if (myInput.getAttribute('data-wordDirection') == 'horizontal') {
                    wordAbbreviation = 'w' + wordAbbreviations[0];
                } else { //vertical:
                    wordAbbreviation = 'w' + wordAbbreviations[1];
                }
            } else if (wordAbbreviations.length < 2) {
                wordAbbreviation = 'w' + wordAbbreviation;
            } else if (me.lastWord == 'w' + wordAbbreviations[0]) {
                wordAbbreviation = 'w' + wordAbbreviations[0];
            } else if (me.lastWord == 'w' + wordAbbreviations[1]) {
                wordAbbreviation = 'w' + wordAbbreviations[1];
            } else {
                return;
            }
            me.lastWord = wordAbbreviation;
            wordLength = me.inputOrder[wordAbbreviation].length;

            myForm = myInput.parentNode;
            while (myForm.tagName.toLowerCase() != 'form') {
                myForm = myForm.parentNode;
            }

            for (i = 0; i < wordLength; i++) {
                if (backspace) {
                    if (me.inputOrder[wordAbbreviation][i] == myInput.name &&
                        me.inputOrder[wordAbbreviation][i - 1] != undefined) {
                        nextInput = me.inputOrder[wordAbbreviation][i - 1];
                    }
                } else {
                    if (me.inputOrder[wordAbbreviation][i] == myInput.name &&
                        me.inputOrder[wordAbbreviation][i + 1] != undefined) {
                        nextInput = me.inputOrder[wordAbbreviation][i + 1];
                    }
                }
            }

            if (nextInput != null) {
                nextInputNode = myForm[nextInput];
                nextInputNode.focus();
                if (backspace && myInput.value == '') {
                    nextInputNode.value = '';
                } else {
                    nextInputNode.select();
                }
            }
        }

        me.checkCrossword = function(e) {
            //checks the answers the user has input and displays which are correct/incorrect

            var myForm, myInputs, myInputsLength, i;

            e = e || window.event;
            e.preventDefault();
            myForm = e.target || e.srcElement;
            myInputs = myForm.getElementsByTagName('input');

            myInputsLength = myInputs.length;
            for (i = 0; i < myInputsLength; i++) {
                if (me.answerKey[myInputs[i].name] != undefined) {
                    if (myInputs[i].value.toLowerCase() != me.answerKey[myInputs[i].name].toLowerCase()) {
                        if (!/ incorrect\b/.test(myInputs[i].parentNode.className = myInputs[i].parentNode.className)) { // eslint-disable-line
                            myInputs[i].parentNode.className = myInputs[i].parentNode.className + ' incorrect';
                        }
                        myInputs[i].parentNode.className = myInputs[i].parentNode.className.replace(/ correct\b/g, '');
                    } else {
                        myInputs[i].parentNode.className = myInputs[i].parentNode.className.replace(/ incorrect\b/g, '');
                        if (!/ correct\b/.test(myInputs[i].parentNode.className = myInputs[i].parentNode.className)) { // eslint-disable-line
                            myInputs[i].parentNode.className = myInputs[i].parentNode.className + ' correct';
                        }
                    }
                }
            }
        }

        function placeAllTermsInGrid(roundDownFirst) {
            //this function places all the terms. roundDownFirst when true rounds the initial word placement down to create a variation allowing for evaluation of most placed terms.

            var i, termsUnplacedLength, placementLocation;

            if (me.termsUnplaced.length < me.termsPlaced.length) {
                me.termsUnplaced = me.termsPlaced;
                me.termsPlaced = [];
                me.termsUnplaced = me.termsUnplaced.concat(me.termsUnplaceable);
                me.termsUnplaceable = [];
                me.grid = [];
            }

            //sort terms:
            me.termsUnplaced = sortWordList(me.termsUnplaced);

            //generate grid:
            termsUnplacedLength = me.termsUnplaced.length;

            generateGrid(me.termsUnplaced[termsUnplacedLength - 1].term.length);

            //place all words from longest to shortest:
            for (i = termsUnplacedLength - 1; i >= 0; i--) {
                placementLocation = findPlacementLocation(i, roundDownFirst);
                if (placementLocation != null) {
                    placeWord(me.termsUnplaced[i], placementLocation);
                } else {
                    //TODO: place without crossing
                }
            }
        }

        function prependCssRules(prependText, styleSheet) { // eslint-disable-line
            var i, cssRulesLength, newStyleSheet, rootClassRegex;

            newStyleSheet = '';
            rootClassRegex = new RegExp('^\\.' + me.rootNode.className.replace(/ +/, '.') + '\\b');
            cssRulesLength = styleSheet.cssRules.length;
            for (i = 0; i < cssRulesLength; i++) {
                if (/^body\b/.test(styleSheet.cssRules[i].selectorText)) {
                    newStyleSheet += styleSheet.cssRules[i].cssText.replace(/^body\b/, prependText + ' ') + '\n';
                } else if (!rootClassRegex.test(styleSheet.cssRules[i].selectorText)) {
                    newStyleSheet += prependText + ' ' + styleSheet.cssRules[i].cssText + '\n';
                } else {
                    newStyleSheet += styleSheet.cssRules[i].cssText + '\n';
                }
            }
            return newStyleSheet;
        }

        function displayDescriptionStyles() { // eslint-disable-line
            var i, myStyleFrontOffset, myStyleBackOffset, newFrontSheet; // eslint-disable-line

            for (i = 0; i < me.termsPlaced.length; i++) {
                me.cardFrontStyleNode.innerHTML = me.termsPlaced[i].description.style;
                myStyleFrontOffset = getStyleSheetOffset(me.cardFrontStyleNode); // eslint-disable-line
                newFrontSheet = prependCssRules('#' + me.descriptionId, document.styleSheets[myStyleFrontOffset]); // eslint-disable-line
                me.cardFrontStyleNode.innerHTML = newFrontSheet;
            }
        }

        function renumberCrossword() {
            let start_list = {};
            let current_order_number = 1;
            // First pass: determine the new order numbers for all words
            for (let row of me.grid) {
                for (let cell of row) {
                    if (cell.firstLetter) {
                        let wordIndexes = cell.wordIndex.split(' ');
                        if (wordIndexes.length === 1) {
                            start_list[wordIndexes[0]] = current_order_number;
                        } else {
                            for (let index of wordIndexes) {
                                if (!start_list.hasOwnProperty(index)) { // eslint-disable-line
                                    start_list[index] = current_order_number;
                                }
                            }
                        }
                        cell.newWordIndex = current_order_number++;
                    }
                }
            }
            // Second pass: replace all word index properties with the newly calculated order
            for (let row of me.grid) {
                for (let cell of row) {
                    if (cell.hasOwnProperty("wordIndex")) { // eslint-disable-line
                        let wordIndexes = cell.wordIndex.split(' ');
                        let newWordIndexes = [];
                        for (let index of wordIndexes) {
                            newWordIndexes.push(start_list[index]);
                        }
                        cell.wordIndex = newWordIndexes.join(' ');
                    }
                }
            }
            // Re-order the termsPlaced array so that the legend numbers match the crossword numbers
            var newTermsPlaced = [];
            for (var i = 1; i <= me.termsPlaced.length; i++) {
                newTermsPlaced[start_list[i] - 1] = me.termsPlaced[i - 1];
            }
            me.termsPlaced = newTermsPlaced;
        }

        me.importJSON = function(json) {
            json.clues.sort((a,b) => {
                return (a.Number*1)-(b.Number*1)
            })
            generateGrid(15)
            me.termsPlaced = []
            for(let clue of json.clues) {
                placeWord(
                    {
                        description: {html: clue.Clue},
                        term: clue.Answer
                    },{
                        x: clue.XPos,
                        y: clue.YPos,
                        direction: clue.Direction == 1 ? "vertical" : "horizontal"
                    }
                )
            }
            cleanUnusedGrid();
            //block the unused spaces:
            blockUnusedSpaces();
            renumberCrossword();
            console.log("Imported:", JSON.parse(JSON.stringify(me.termsPlaced)))
        }

        // Export this crossword data in a format that works with Studies Weekly Online
        me.exportJSON = function() {
            var clues = [];
            var minX = me.termsPlaced[0].x;
            var minY = me.termsPlaced[0].y;
            for (var i = 0; i < me.termsPlaced.length; i++) {
                var clue = me.termsPlaced[i];
                minX = Math.min(minX, clue.x);
                minY = Math.min(minY, clue.y);
                clues.push({
                    "Clue": clue.description.html,
                    "term_id": me.getTermIdByTerm(clue.term),
                    "clue_id": me.getClueIdByDescription(clue.description.html),
                    "definition_id": me.getDefinitionIdByDescription(clue.description.html),
                    "Answer": clue.term,
                    "XPos": clue.x,
                    "YPos": clue.y,
                    "Direction": clue.direction === "horizontal" ? 0 : 1,
                    "Number": i + 1
                });
            }
            var width = 0;
            var height = 0;
            for (i = 0; i < clues.length; i++) {
                // Rescale the X/Y positions of all terms with 0,0 as the lowest coordinate
                clues[i].XPos -= minX;
                clues[i].YPos -= minY;
                // Calcuate the width/height by determining the right-most coordinate and bottom-most coordinate
                width = Math.max(width, clues[i].XPos + (clues[i].Direction ? 0 : clues[i].Answer.length));
                height = Math.max(height, clues[i].YPos + (clues[i].Direction ? clues[i].Answer.length : 0));
            }
            return JSON.stringify({
                "clues": clues,
                "width": width,
                "height": height,
                "seed": me.myParams.seed
            });
        }

        me.getTermIdByTerm = function(term) {
            for (var pair of me.myParams.termDescriptionPairs) {
                if (pair.term === term) {
                    return pair.term_id;
                }
            }
            return null;
        }

        me.getClueIdByDescription = function(description) {
            for (var pair of me.myParams.termDescriptionPairs) {
                if (pair.description.html === description) {
                    return pair.description.clue_id;
                }
            }
            return null;
        }

        me.getDefinitionIdByDescription = function(description) {
            for (var pair of me.myParams.termDescriptionPairs) {
                if (pair.description.html === description) {
                    return pair.description.definition_id;
                }
            }
            return null;
        }

        me.getUsedVocabTerms = function() {
            var terms = [];
            for (var i = 0; i < me.termsPlaced.length; i++) {
                terms.push(me.termsPlaced[i].description.html);
            }
            return terms;
        }

        me.grid2Html = function () {
            //converts the grid that has only existed in RAM to an html table for display

            var htmlNode, formContainer, myForm, myTable, gridLength, gridWidth, row, column, myTrs, myTds, myDivs, myInputs, inputNum, i, wordAbbreviations, wordAbbreviationsLength, myNumber, termNumber;

            htmlNode = document.createElement('div');
            htmlNode.className = 'crossword d-xl-flex align-items-center';
            formContainer = document.createElement('div');
            formContainer.className = '';
            htmlNode.appendChild(formContainer);
            myForm = document.createElement('form');
            myForm.className = '';
            myForm.onsubmit = me.checkCrossword;
            formContainer.appendChild(myForm);
            myTable = document.createElement('table');
            myTrs = [];
            myTds = [];
            myDivs = [];
            myInputs = [];
            inputNum = 0;
            gridLength = me.grid.length;
            gridWidth = me.grid[0].length;
            for (row = 0; row < gridLength; row++) {
                myTrs[row] = document.createElement('tr');
                for (column = 0; column < gridWidth; column++) {
                    myTds[column] = document.createElement('td');
                    myDivs[column] = document.createElement('div');
                    if (me.grid[row][column].blocked) {
                        myTds[column].className = 'blocked';
                    } else {
                        if (me.grid[row][column].firstLetter == true) {
                            myTds[column].className = 'wordStart';
                            if (me.grid[row][column].wordDirection == 'horizontal') {
                                termNumber = me.grid[row][column].wordIndex.replace(/ +\d+$/, '');
                            } else { //vertical:
                                termNumber = me.grid[row][column].wordIndex.replace(/^\d+ +/, '');
                            }
                            myNumber = document.createElement('span');
                            myNumber.className = 'wordNumber';
                            myNumber.innerHTML = termNumber;
                        }
                        myInputs[inputNum] = document.createElement('input');
                        myInputs[inputNum].type = 'text';
                        if (me.myParams.preComplete) {
                            myInputs[inputNum].value = me.grid[row][column].letter;
                        }
                        myInputs[inputNum].name = 'w-' + me.grid[row][column].wordIndex.replace(/ +/, '_') + 'l-' + inputNum;
                        me.answerKey[myInputs[inputNum].name] = me.grid[row][column].letter;
                        wordAbbreviations = me.grid[row][column].wordIndex.split(/ +/);
                        wordAbbreviationsLength = wordAbbreviations.length;
                        for (i = 0; i < wordAbbreviationsLength; i++) {
                            if (me.inputOrder['w' + wordAbbreviations[i]] == undefined) {
                                me.inputOrder['w' + wordAbbreviations[i]] = [];
                            }
                            me.inputOrder['w' + wordAbbreviations[i]].push(myInputs[inputNum].name);
                        }
                        myInputs[inputNum].setAttribute('maxlength', 1);
                        myInputs[inputNum].setAttribute('disabled', true);
                        myInputs[inputNum].onkeyup = focusNextInput;
                        myInputs[inputNum].onkeydown = recordInputValue;
                        myInputs[inputNum].onclick = function() {
                            me.lastWord = null;
                        }
                        //                  myInputs[inputNum].value = me.grid[row][column].letter; //reveal the results for testing
                        if (me.grid[row][column].firstLetter == true) {
                            myInputs[inputNum].setAttribute('data-wordDirection', me.grid[row][column].wordDirection);
                            myDivs[column].appendChild(myNumber);
                            myInputs[inputNum].setAttribute('data-firstLetter', 1);
                            myInputs[inputNum].id = 'w' + termNumber;
                        }
                        myDivs[column].appendChild(myInputs[inputNum]);
                        myTds[column].appendChild(myDivs[column]);
                        inputNum++;
                    }
                    myTrs[row].appendChild(myTds[column]);
                }
                myTable.appendChild(myTrs[row]);
            }
            myForm.appendChild(myTable);
            // myReset = document.createElement('input');
            // myReset.type = 'button';
            // myReset.value = 'Clear Crossword'
            // myReset.onclick = function(e) {
            //  var clearConfirm;
            //  clearConfirm = confirm('This will COMPLETELY clear the crossword and start over. Continue with clear?');
            //  if (clearConfirm) {
            //      clearCrossword(myForm);
            //  }
            // }
            // mySubmit = document.createElement('input');
            // mySubmit.type = 'submit';
            // mySubmit.value = 'Check Answers'
            // myForm.appendChild(myReset);
            // myForm.appendChild(mySubmit);
            return htmlNode;
        }

        me.cleanupGride = function(){
            cleanUnusedGrid();

            //block the unused spaces:
            blockUnusedSpaces();

            renumberCrossword();
        }
        me.descriptions2Html = function (separateDirections) {
            //displays the clues as html lists. If separateDirections is true, across and down are displayed separately.

            var numberOfTerms, myOlAcross, myOlDown, myOl, myLis, descriptionNum, myRootNode, acrossHeading, downHeading, myHeading;

            myRootNode = document.createElement('div');
            myRootNode.className = 'mt-xl-0 ml-xl-3 ml-0 mt-3 crosswordDescriptions';
            if (separateDirections) {
                myOlAcross = document.createElement('ul');
                myOlDown = document.createElement('ul');
                myOlAcross.className = 'across';
                myOlDown.className = 'down mb-0';
            } else {
                myOl = document.createElement('ul');
            }
            myLis = [];
            numberOfTerms = me.termsPlaced.length;
            for (descriptionNum = 0; descriptionNum < numberOfTerms; descriptionNum++) {
                myLis[descriptionNum] = document.createElement('li');
                // myLis[descriptionNum].className = '';
                myLis[descriptionNum].innerHTML = (descriptionNum + 1) + ". " + me.termsPlaced[descriptionNum].description.html;
                myLis[descriptionNum].onmouseover = highlightSpaces;
                myLis[descriptionNum].onmouseout = unHighlightSpaces;
                myLis[descriptionNum].onclick = positionCursor;
                myLis[descriptionNum].setAttribute('value', descriptionNum + 1);
                if (separateDirections) {
                    if (me.termsPlaced[descriptionNum].direction == 'horizontal') {
                        myOlAcross.appendChild(myLis[descriptionNum]);
                    } else {
                        myOlDown.appendChild(myLis[descriptionNum]);
                    }
                } else {
                    myOl.appendChild(myLis[descriptionNum]);
                }
            }
            if (separateDirections) {
                acrossHeading = document.createElement('h5');
                downHeading = document.createElement('h5');
                acrossHeading.innerHTML = 'Across';
                downHeading.innerHTML = 'Down';
                myRootNode.appendChild(acrossHeading);
                myRootNode.appendChild(myOlAcross);
                myRootNode.appendChild(downHeading);
                myRootNode.appendChild(myOlDown);
            } else {
                myHeading = document.createElement('h5');
                myHeading.innerHTML = 'Descriptions';
                myRootNode.appendChild(myHeading);
                myRootNode.appendChild(myOl);
            }

            return myRootNode;
        }

        me.construct = function() {
            //this is the function that puts everything together
            var i, a, t, crosswordNode, descriptionLists, gridWidth, gridHeight, dimensionDifference, dimensionTotal, gridScores, gridScoresLength, numberOfAttempts, placementLocation;
            gridScores = [];

            //generate X number of wordfinds and choose the most square and compact of them:
            numberOfAttempts = me.numberOfAttempts;
            for (a = 0; a < numberOfAttempts; a++) {
                me.termsUnplaced = cloneObject(me.myParams.termDescriptionPairs);
                //5 is the smallest possible number of terms
                if (me.myParams.subset != undefined && me.myParams.subset != null && me.myParams.subset >= 5) {
                    me.termsUnplaced.sort(function() {
                        return 0.5 - customRandom();
                    });
                    me.termsUnplaced = me.termsUnplaced.splice(0, me.myParams.subset);
                }
                //randomize order of remaining terms (increases variety, but usually results in fewer placed terms):
                if (a > 0) { //try first without randomnizing
                    me.termsUnplaced.sort(function() {
                        return 0.5 - customRandom();
                    });
                }
                placeAllTermsInGrid(getRandomBoolean());

                //only include if all terms were placed:
                //          if (me.termsPlaced.length == me.termsUnplaced.length) {
                //clean up unused grid:
                cleanUnusedGrid();
                me.grids.push(cloneObject(me.grid));
                me.answerKeys.push(cloneObject(me.answerKey));
                me.termsPlaceds.push(cloneObject(me.termsPlaced));
                me.termsUnplaceables.push(cloneObject(me.termsUnplaceable));
                //          }
                gridScores.push({
                    score: null,
                    offset: null,
                    termsPlacedNum: me.termsPlaced.length
                });

                //evaluate the generated grids for the most compact:
                gridWidth = me.grids[a][0].length;
                gridHeight = me.grids[a].length;
                dimensionDifference = Math.abs(gridWidth - gridHeight);
                dimensionTotal = gridWidth + gridHeight;
                gridScores[a].score = dimensionDifference + dimensionTotal;
                //this is later used to identify the best grid:
                gridScores[a].offset = a;

                //          console.log(a+':'+me.termsPlaced.length+':'+me.myParams.termDescriptionPairs.length);
                if (me.termsPlaced.length == me.myParams.termDescriptionPairs.length) {
                    break;
                }

                me.grid = [];
                me.answerKey = [];
                me.termsPlaced = [];
                me.termsUnplaceable = [];

            }

            //this sort eliminates grids that didn't place terms:
            gridScores.sort(sortGridPlacedTerms);
            gridScoresLength = gridScores.length;
            for (t = 0; t < gridScoresLength; t++) {
                if (gridScores[0].termsPlacedNum < gridScores[gridScores.length - 1].termsPlacedNum) {
                    gridScores.splice(0, 1);
                }
            }

            //      gridScores.splice(0,Math.ceil(numberOfAttempts-(numberOfAttempts/5)));

            //this sorts by the most compact and square grid:
            gridScores.sort(sortGridScore);
            me.grid = me.grids[gridScores[0].offset];
            me.answerKey = me.answerKeys[gridScores[0].offset];
            me.termsPlaced = me.termsPlaceds[gridScores[0].offset];
            me.termsUnplaceable = me.termsUnplaceables[gridScores[0].offset];

            //check to see if there are still unplaced words:
            if (me.termsPlaced.length != me.myParams.termDescriptionPairs.length) {
                //          alert(JSON.stringify(me.termsUnplaceable));
                //place all unplaced words from longest to shortest:
                me.termsUnplaced = me.termsUnplaceable;
                for (i = me.termsUnplaced.length - 1; i >= 0; i--) {
                    placementLocation = findPlacementLocation(i, false, true);
                    if (placementLocation != null) {
                        placeWord(me.termsUnplaced[i], placementLocation);
                    }
                }
            }

            //clean up unused grid:
            cleanUnusedGrid();

            //block the unused spaces:
            blockUnusedSpaces();

            renumberCrossword();

            crosswordNode = me.grid2Html();
            if (!me.previewMode) {
                descriptionLists = me.descriptions2Html(me.myParams.separateDescriptions);
                crosswordNode.appendChild(descriptionLists);
            }
            me.placementNode.appendChild(crosswordNode);
        }

        me.construct();
    }
}
